import { TFunction } from 'react-i18next';
import * as yup from 'yup';

import { FormFieldsConfig } from 'components/DocumentForm';

export const getRequiredFields = (fieldsConfig: FormFieldsConfig[], t: TFunction) => {
  const nested = {} as Record<string, any>;

  const getReqired = (arr: FormFieldsConfig[]) =>
    arr.reduce<Record<string, any>>((obj, field) => {
      if (field.nested) {
        nested[field.id] = { ...nested[field.id], ...getReqired(field.nested) };
      } else if (field.required) {
        obj[field.id] = yup.string().required(t('warning.required'));
      }
      return obj;
    }, {});

  return {
    ...getReqired(fieldsConfig),
    ...Object.keys(nested).reduce<Record<string, any>>((obj, field) => {
      if (Object.keys(nested[field]).length) {
        obj[field] = yup.object().shape(nested[field]);
      }
      return obj;
    }, {}),
  };
};
